export const ALLIED_INITIATE_PROPOSAL_FORM_ID = 'allied-initiate-proposal-form';
